import { Immutable } from "immer";
import React from "react";
import { isoSyncStoreID } from "tsi-common-react/src/models/nominals";

import { templates } from "@reactivated";

import { LocatorSendSingleStore } from "../LocatorSendSingleStore";

type IProps = Immutable<templates.LocatorSendStoreDetailsTemplate>;

export const LocatorSendSingleStoreSSR = (props: IProps): React.JSX.Element => {
    return (
        <LocatorSendSingleStore storeID={isoSyncStoreID.wrap(props.store_id)} />
    );
};
